/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ENDPOINTS from 'constants/endpoints';
class MyTraderaMenu extends Component {
    state = {
        show: false,
        hoverContainer: false
    };

    toggleShow = show => {
        window.clearTimeout(this.toggleShowTimeoutId);
        this.toggleShowTimeoutId = window.setTimeout(() => {
            if (this.state.show !== show) {
                this.setState({ show: show });
            }
        }, 100);
    };

    componentWillReceiveProps(nextProps) {
        this.toggleShow(nextProps.hoverUser);
    }

    onMouseOverContainer = () => this.toggleShow(true);

    onMouseOutContainer = () => this.toggleShow(false);

    renderLogout = () => (
        <a
            className="dropdown-area-content-list-item-link site-header-menu-login-link col-sm pl-4"
            href="/login/logout"
            data-ga-category="Header"
            data-ga-action="Navigation"
            data-ga-label="Mitt Tradera - Logga ut">
            Logga ut
        </a>
    );

    render() {
        const {
            memberId,
            cleanedMemberAlias,
            isLoggedIn,
            showCouponationMenu,
            showMessagingLink,
            showPayments2Menu,
            showKlarnaMenu,
            preventNavigationAndShowLogin,
            threadsUnread
        } = this.props;
        return (
            <div
                className="site-header-menu-links-container"
                onMouseOver={this.onMouseOverContainer}
                onMouseOut={this.onMouseOutContainer}
                data-main-myt-menu>
                <nav
                    className={`dropdown-area site-header-menu-links ${
                        this.state.show ? 'site-header-menu-links--show' : ''
                    }`}
                    data-site-header-menu-links>
                    <ul className="dropdown-area-content">
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/overview"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/overview'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Översikt">
                                Översikt
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/wish-list"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/wish-list'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Minneslistan">
                                Minneslista
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/saved-searches"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/saved-searches'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Sparade sökningar">
                                Bevakningar
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/favourite-sellers"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/favourite-sellers'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Favoritsäljare">
                                Favoritsäljare
                            </a>
                        </li>
                        {showMessagingLink && (
                            <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                                <a
                                    className="dropdown-area-content-list-item-link"
                                    href="/messaging"
                                    rel="nofollow"
                                    onClick={e =>
                                        preventNavigationAndShowLogin(
                                            e,
                                            '/messaging'
                                        )
                                    }
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Mitt Tradera - Meddelanden">
                                    Meddelanden
                                    {threadsUnread > 0 && (
                                        <span className="slim-header__notification slim-header__notification-bubble">
                                            {threadsUnread}
                                        </span>
                                    )}
                                </a>
                            </li>
                        )}
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/active-items"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/active-items'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Pågående budgivningar">
                                Pågående budgivningar
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/purchases"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/purchases'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Mina köp">
                                Mina köp
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/items-lost"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/items-lost'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Ej vunna">
                                Ej vunna
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/active"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/active'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Aktiva annonser">
                                Aktiva annonser
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/sold"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(e, '/my/sold')
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Sålda">
                                Sålda
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/unsold"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/unsold'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Ej sålda">
                                Ej sålda
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/sold/picklist"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/sold/picklist'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Plocklista">
                                Plocklista
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/leave-feedback/buyer?transactionId=0"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/leave-feedback/buyer?transactionId=0'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Lämna omdöme på säljare">
                                Lämna omdöme på säljare
                            </a>
                        </li>
                        {isLoggedIn ? (
                            [
                                <li
                                    className="dropdown-area-content-list-item"
                                    key="fpk">
                                    <a
                                        className="dropdown-area-content-list-item-link"
                                        href="/my/leave-feedback/seller?transactionId=0"
                                        rel="nofollow"
                                        data-ga-category="Header"
                                        data-ga-action="Navigation"
                                        data-ga-label="Mitt Tradera - Lämna omdöme på köpare">
                                        Lämna omdöme på köpare
                                    </a>
                                </li>,
                                <li
                                    className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section"
                                    key="mo">
                                    <a
                                        className="dropdown-area-content-list-item-link"
                                        href={`/profile/feedback/${memberId}/${cleanedMemberAlias}`}>
                                        Mina omdömen
                                    </a>
                                </li>
                            ]
                        ) : (
                            <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                                <a
                                    className="dropdown-area-content-list-item-link"
                                    href="/my/leave-feedback/seller?transactionId=0"
                                    rel="nofollow"
                                    onClick={e =>
                                        preventNavigationAndShowLogin(
                                            e,
                                            '/my/leave-feedback/seller?transactionId=0'
                                        )
                                    }
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Mitt Tradera - Lämna omdöme på köpare">
                                    Lämna omdöme på köpare
                                </a>
                            </li>
                        )}
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/profile"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/profile'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Inställningar">
                                Inställningar
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a
                                className="dropdown-area-content-list-item-link"
                                href="/my/Invoices?page=1"
                                rel="nofollow"
                                onClick={e =>
                                    preventNavigationAndShowLogin(
                                        e,
                                        '/my/Invoices?page=1'
                                    )
                                }
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Mitt Tradera - Fakturor och avgifter">
                                Fakturor &amp; avgifter
                            </a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            {showPayments2Menu ? (
                                <a
                                    className="dropdown-area-content-list-item-link"
                                    href="/my/Payments2"
                                    rel="nofollow"
                                    onClick={e =>
                                        preventNavigationAndShowLogin(
                                            e,
                                            '/my/Payments2'
                                        )
                                    }
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Mitt Tradera - Betalning">
                                    Utbetalningar
                                </a>
                            ) : (
                                <a
                                    className="dropdown-area-content-list-item-link"
                                    href="/my/Payments"
                                    rel="nofollow"
                                    onClick={e =>
                                        preventNavigationAndShowLogin(
                                            e,
                                            '/my/Payments'
                                        )
                                    }
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Mitt Tradera - Betalning">
                                    Utbetalningar
                                </a>
                            )}
                        </li>
                        {isLoggedIn &&
                            showKlarnaMenu && (
                                <li className="dropdown-area-content-list-item">
                                    <a
                                        className="dropdown-area-content-list-item-link"
                                        href="/my/klarna"
                                        rel="nofollow"
                                        data-ga-category="Header"
                                        data-ga-action="Navigation"
                                        data-ga-label="Mitt Tradera - Klarna">
                                        Klarna
                                    </a>
                                </li>
                            )}

                        {showCouponationMenu && (
                            <li className="dropdown-area-content-list-item dropdown-area-content-list-item-start-section">
                                <a
                                    className="dropdown-area-content-list-item-link"
                                    href="/rabattkoder"
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Mitt Tradera - Rabattkoder">
                                    Rabattkoder
                                </a>
                            </li>
                        )}

                        <li className="dropdown-area-content-list-item site-header-menu-login-links py-2">
                            {isLoggedIn
                                ? this.renderLogout()
                                : [
                                      <a
                                          key="logga-in"
                                          className="site-header-menu-login-link ml-4 pl-2 pr-2"
                                          href="/login"
                                          rel="nofollow"
                                          data-ga-category="Header"
                                          data-ga-action="Navigation"
                                          data-ga-label="Mitt Tradera - Logga in"
                                          onClick={e =>
                                              preventNavigationAndShowLogin(
                                                  e,
                                                  '/'
                                              )
                                          }>
                                          Logga in
                                      </a>,
                                      '/',
                                      <a
                                          key="bli-medlem"
                                          className="site-header-menu-login-link mx-2"
                                          href="/register"
                                          data-ga-category="Header"
                                          data-ga-action="Navigation"
                                          data-ga-label="Bli medlem">
                                          Bli medlem
                                      </a>
                                  ]}
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }
}

MyTraderaMenu.propTypes = {
    isLoggedIn: PropTypes.bool,
    showPayments2Menu: PropTypes.bool,
    showKlarnaMenu: PropTypes.bool,
    showCouponationMenu: PropTypes.bool,
    hoverUser: PropTypes.bool,
    cleanedMemberAlias: PropTypes.string,
    memberId: PropTypes.number
};

export default MyTraderaMenu;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/mytradera-menu/mytradera-menu.jsx